<template>
    <!-- 仓位列表 -->
    <div id="agentEntrustList">
        <b-card class="header-top" ref="headerH">
            <b-row>
                <b-col lg="9">
                    <!--搜索uid-->
                    <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
                        <b-form-input v-model.trim="searchUid" maxLength="19" placeholder=""></b-form-input>
                    </b-form-group>
                    <!--订单号-->
                    <b-form-group class="find-middle" :label="$t('lanV4.agentOrderNum')">
                        <b-form-input v-model.trim="searchOrderNum" maxLength="19" placeholder=""></b-form-input>
                    </b-form-group>
                    <!--合约名称-->
                    <b-form-group :label="$t('positionList.contractId')" class="find-middle">
                        <v-select class="find-select" v-model="contractId" :options="contractList">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>
                    <!--订单类型-->
                    <b-form-group :label="$t('entrustedList.type')" class="find-middle">
                        <v-select class="find-select" v-model="type" :options="typeList">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>
                    <!--订单状态-->
                    <b-form-group :label="$t('entrustedList.status')" class="find-middle">
                        <v-select class="find-select" v-model="status" :options="statusList">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>

                    <!-- 创建时间 -->
                    <b-form-group :label="$t('positionList.cTime')" class="find-middle">
                        <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
                            range-separator="-" :start-placeholder="$t('common.startDate')"
                            :end-placeholder="$t('common.endDate')" @change="handleChangeDate" :clearable="false"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </b-form-group>
                </b-col>
                <b-col lg="3" class="header-right-btn">
                    <div class="find-middle find-btnBox">
                        <b-button variant="primary" @click="query">
                            <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                        <use xlink:href="#icon-v4_17"></use>
                      </svg> -->
                            {{ $t("common.search") }}</b-button>
                        <b-button variant="light" @click="reset">
                            <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                        <use xlink:href="#icon-v4_3"></use>
                      </svg> -->
                            {{ $t("common.reset") }}</b-button>
                    </div>
                </b-col>
            </b-row>
            <!-- 头部分割线 -->
            <div class="header-top-bottom-bor"></div>
        </b-card>
        <b-card class="table-card">
            <div slot="header">
                <div class="table-title float-left">
                    <!-- 数据总览 标题 -->
                    <span v-if="pages.total > 0">
                        {{ $t("el.pagination.total", { total: pages.total }) }}
                    </span>
                </div>
                <!-- <v-page
                  class="float-left"
                  v-if="pages.total > 0"
                  :total-rows="pages.total"
                  :perPage="pages.size"
                  :pageOptions="pages.options"
                  :currentPage="pages.page"
                  @initialize="pageChange"
                  layout="total,sizes"
                >
                </v-page> -->
                <!-- 导出 -->
                <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
                    :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
                    <svg class="icon icon-16" aria-hidden="true">
                        <use xlink:href="#icon-v4_6_h"></use>
                    </svg>
                    {{ exportButtonText }}
                    <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
                        <use xlink:href="#icon-v4_loading"></use>
                    </svg>
                </b-button>
            </div>
            <b-row>
                <b-col class="table-section">
                    <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
                        @sort-change="sortChanged" :cell-class-name="addEnClass"
                        :default-sort="{ prop: 'totalAmount', order: 'descending' }">
                        <template slot="empty">
                            <load-skeleton v-show="loading" :columns="6" :rows="10"
                                :haveLeftNumber="false"></load-skeleton>
                            <h4 class="common-table-noData" v-show="!loading">
                                <img src="../../assets/images/v4_nodata.png" alt="" />
                                <div class="noData-text">
                                    {{ $t("common.noData") }}
                                </div>
                            </h4>
                        </template>
                        <!--  序号 -->
                        <!-- <el-table-column prop="sort" align="left" :label="$t('common.sort')">
                        </el-table-column> -->
                        <!-- 订单号 -->
                        <el-table-column align="left" :label="$t('entrustedList.id')" prop="orderId" width="200">
                            <template slot-scope="scope">
                                {{ scope.row.orderId }}
                            </template>
                        </el-table-column>
                        <!-- uid -->
                        <el-table-column align="right" :label="$t('lanV4.newUid')" prop="uid" width="130" />
                        <!-- 状态 -->
                        <el-table-column align="right" :label="$t('entrustedList.status')" prop="orderStatus"
                            width="160">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.orderStatus }}
                                </span>

                                <!-- <span v-if="scope.row.memo">
                                    <svg :id="scope.row.id" class="icon icon-14 icon-wh" aria-hidden="true">
                                        <use xlink:href="#icon-v4_wh"></use>
                                    </svg>

                                    <b-tooltip :target="scope.row.id" :title="momeText[scope.row.memo - 1]"></b-tooltip>
                                </span> -->
                            </template>
                        </el-table-column>
                        <!-- 合约 -->
                        <el-table-column align="right" :label="$t('common.contract')" prop="contractName" width="250">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sideType === 'BUY'" class="green">{{ scope.row.orderSide }}</span>
                                <span v-if="scope.row.sideType === 'SELL'" class="red">{{ scope.row.orderSide }}</span>
                                <span> {{ scope.row.contractName }}</span>
                            </template>
                        </el-table-column>
                        <!-- 订单类型 -->
                        <el-table-column align="right" :label="$t('entrustedList.type')" prop="orderType" width="150" />
                        <!-- 仓位方向 -->
                        <el-table-column align="right" :label="$t('entrustedList.open')" prop="open" width="150" />
                        <!-- 委托价值 -->
                        <el-table-column align="right" :label="$t('lanV4.entrustedValue')" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.orderValue }}</span>
                            </template>
                        </el-table-column>
                        <!-- 成交均价 -->
                        <el-table-column align="right" :label="$t('entrustedList.avgPrice')" prop="dealPrice"
                            width="150" />
                        <!-- 委托数量 -->
                        <el-table-column align="right" :label="$t('entrustedList.volume')" prop="volume" width="150" />
                        <!-- 成交数量 -->
                        <el-table-column align="right" :label="$t('entrustedList.dealVolume')" prop="dealVolume"
                            width="150" />
                        <!-- 手续费 -->
                        <el-table-column align="right" :label="$t('entrustedList.fee')" prop="tradeFee" width="150">
                            <template slot-scope="scope">
                                <span>{{ scope.row.fee }} </span>

                            </template>
                        </el-table-column>
                        <!-- 创建时间 -->
                        <el-table-column align="right" :label="$t('positionList.cTime')" prop="startTime" width="180" />
                        <!-- 操作 -->
                        <!-- <el-table-column prop="action" :label="$t('common.find')" fixed="right" align="right"
                            width="100">
                            <template slot-scope="scope">
                                返佣明细
                                <b-button size="sm" variant="outline-primary" @click="goJump(scope.row)">
                                    {{ $t("lanV4.Rebatedetail") }}
                                </b-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </b-col>
            </b-row>
            <b-row class="mar-t-20">
                <b-col>
                    <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size"
                        :pageOptions="pages.options" :currentPage="pages.page" @initialize="pageChange"></v-page>
                </b-col>
            </b-row>
        </b-card>

        <!-- 导出10000条提示 -->
        <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
            no-close-on-backdrop id="code-modal">
            <div class="body-content">
                <div class="expor-number-tip">
                    {{
                        $t("exportsModal.text2", {
                            pagesTotal: pages.total,
                            maxNum: this.exportNumLimit,
                        })
                    }}
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
                    $t("common.cancel")
                    }}</b-button>
                <b-button class="coustom-btn" variant="primary" @click="exports('true')"
                    :class="!isexportIng ? 'lodingSattus' : ''">
                    <template v-if="!isexportIng">
                        {{ $t("common.exportIng") }}
                    </template>
                    <template v-else>
                        <!-- 继续导出 -->
                        {{ $t("exportsModal.text3") }}
                    </template>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";


export default {
    name: "agentList",
    mixins: [commonMixin],
    components: {
        headerUpdate,
    },
    data() {
        return {
            searchUid: null, // uid
            searchOrderNum: null,//订单号
            type: null,//订单类型
            status: null,//订单状态
            contractList: [],//合约名称
            contractId: null,//合约id
            dateArray: [new Date().getTime() - 86400000 * 7, new Date().getTime()],
            beginDate: null,
            endDate: null,
            // 当天之后的时间无法选择
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > window.Date.now();
                },
            },
            pages: {
                page: 1, // 当前页数
                size: 10, // 页数大小
                options: [10, 40, 60, 100], // 页数大小选择
                total: 0, // 总页数
            },
            notData: true,
            loading: true,
            tableList: [],
            modalShow: false,
            isexportIng: true,
            sortBy: null, //预先排序的字段
            sortDesc: true, //预先降序
            sortName: "totalAmount", //默认排序字段
            sortSet: 1, //默认倒序
            modalType: null,
        };
    },
    computed: {
        exportButtonText() {
            if (!this.isexportIng) {
                return this.$t("common.exportIng"); // '正在导出'
            }
            return this.$t("common.export");
        },
        // 订单类型
        typeList() {
            return [
                { label: this.$t('common.all'), value: null },
                { label: this.$t('entrustedList.text1'), value: 1 },
                { label: this.$t('entrustedList.text2'), value: 2 },
                { label: 'IOC', value: 3 },
                { label: 'FOK', value: 4 },
                { label: 'PostOnly', value: 5 },
            ]
        },
        //订单状态
        statusList() {
            return [
                { label: this.$t('common.all'), value: null },
                { label: this.$t('lanV4.IncompleteFilled'), value: 0 }, //未完全成交(包含原【初始订单】、【新订单】和【部分成交】)
                { label: this.$t('lanV4.CompleteFilled'), value: 1 },//完全成交(原完全成交)
                { label: this.$t('lanV4.Cancelled'), value: 2 },//已撤单 //包含原【已撤单】和【待撤单】
                { label: this.$t('lanV4.Abnormal'), value: 3 },//异常订单 //原【异常订单】和【无法处理的异常单】
            ]
        },
        momeText() {
            return [
                this.$t("entrustedList.addText1"),
                this.$t("entrustedList.addText2"),
                this.$t("entrustedList.addText21"),
                this.$t("entrustedList.addText4"),
                this.$t("entrustedList.addText5"),
                this.$t("entrustedList.addText6"),
                this.$t("entrustedList.addText7"),
                this.$t("entrustedList.addText8"),
                "",
                "",
                this.$t("entrustedList.addText19"),
                this.$t("entrustedList.addText20"),
                // '用户主动撤销',
                // '订单异常，被系统撤销',
                //仓位被强平，系统撤销
                // '市价单对手盘不足',
                // 'FOK订单无法全成交时被系统撤销',
                // 'IOC订单无法立即成交时部分委托被系统撤销',
                // 'POST ONLY订单无法成为被动单就系统撤销',
                // '仓位不存在，平仓委托被系统撤销',
                // 系统撤销
                //仓位被ADL，系统撤销

            ];
        },
    },
    watch: {
        searchUid(v) {
            if (v) {
                this.$nextTick(() => {
                    this.searchUid = fixInput(v, 0, { num: 1 });
                });
            }
        },
        searchOrderNum(v) {
            if (v) {
                this.$nextTick(() => {
                    this.searchOrderNum = fixInput(v, 0, { num: 1 });
                });
            }
        },
    },
    created() {
        this.handleChangeDate();
        this.getContractName()
        this.type = this.typeList[0]
        this.status = this.statusList[0]
        this.contractId = this.contractList[0]
    },
    methods: {
        // 选择时间
        handleChangeDate() {
            this.beginDate = this.dateArray[0];
            this.endDate = this.dateArray[1];
        },
        //    跳转返佣明细
        goJump(row) {
            const queryObj = {
                orderId: row.orderId,
                returnTo: 0,
                startTime: null,
                endTime: null,
                btnType: "entrust", //查看
            };
            this.$router.push({ path: "/agentRebateDetial", query: queryObj });
        },
        // 英文数字字体
        addEnClass({ row, column }) {
            switch (column.property) {
                case "uid":
                    return "enNum";
                case "pid":
                    return "enNum";
                case "tradeAmount":
                    return "enNum";
                case "fee":
                    return "enNum";
                case "returnAmount":
                    return "enNum";
            }
        },
        // 排序变化
        sortChanged(ctx) {
            switch (ctx.prop) {
                case "tradeAmount":
                    this.sortName = "tradeAmount";
                    break;
                case "fee":
                    this.sortName = "fee";
                    break;
                case "returnAmount":
                    this.sortName = "returnAmount";
                    break;
            }
            this.sortSet = ctx.order === "descending" ? 1 : 0;
            this.getData();
        },
        // 搜索
        query() {
            this.pages.page = 1;
            this.loading = true;
            this.getData();
        },
        // 重置
        reset() {
            this.searchUid = null;
            this.searchOrderNum = null;
            this.type = this.typeList[0]
            this.status = this.statusList[0]
            this.contractId = this.contractList[0]
            this.dateArray = [
                new Date().getTime() - 86400000 * 7,
                new Date().getTime(),
            ];

            this.handleChangeDate();
        },
        // 获取合约名称
        getContractName() {
            const paramsData = {
                brokerId: undefined,
            }
            this.$http({
                url: this.$store.state.url.agent.getAllOpenContract,
                params: paramsData,
                method: "get",
                // apiType: "fe-json-server",
            }).then(({ data, code, msg }) => {
                if (data && code.toString() === '0') {
                    let arr = [{ label: this.$t('common.all'), value: null }]
                    if (data.length) {
                        data.map((item) => {
                            arr.push({ label: item.contractOtherName ? item.contractOtherName : item.contractName, value: item.id })
                        })
                    }
                    this.contractList = arr
                    this.contractId = arr[0];
                }
                this.getData();
            })
        },
        // 获取数据列表
        getData() {
            this.loading = true;
            this.tableList = [];
            const paramsData = {
                uid: this.searchUid,
                orderId: this.searchOrderNum,
                contractId: this.contractId ? this.contractId.value : null,
                orderType: this.type ? this.type.value : null,
                orderStatus: this.status ? this.status.value : null,
                startTime: this.dateArray && this.dateArray[0] ? this.beginDate : null,
                endTime: this.dateArray && this.dateArray[1] ? this.endDate : null,
                pageNum: this.pages.page,
                pageSize: this.pages.size,
                isExport: 0,
            };
            this.$http({
                url: this.$store.state.url.agent.orderPage,
                params: paramsData,
                // method: "get",
                // apiType: "fe-json-server",
            })
                .then(({ data, code, msg }) => {
                    this.loading = false;
                    if (data && code.toString() === "0") {
                        this.setData(data);
                    } else {
                        this.$bus.$emit("alert", { type: "error", message: msg });
                    }
                })
                .catch((e) => {
                    this.loading = false;
                });
        },
        setData(datas) {
            console.log(datas, 'records')
            const { total, records } = datas
            this.pages.total = total ? total : 0
            let arr = []
            if (records && records.length) {
                records.map((item, index) => {
                    if (item.orderType === 1) {
                        item.typeText = this.$t('entrustedList.text1')
                    } else if (item.orderType === 2) {
                        item.typeText = this.$t('entrustedList.text2')
                    } else if (item.orderType === 3) {
                        item.typeText = 'IOC'
                    } else if (item.orderType === 4) {
                        item.typeText = 'FOK'
                    } else if (item.orderType === 5) {
                        item.typeText = 'PostOnly'
                    } else if (item.orderType === 9) {
                        item.typeText = this.$t('delivery.typeTxt1')
                        // 系统平仓
                    }
                    else if (item.orderType === 10) {
                        item.typeText = this.$t('delivery.typeTxt2')
                        // 系统交割
                    }
                    arr.push({
                        'sort': (this.pages.page - 1) * this.pages.size + (index + 1),//序号
                        'orderId': item.orderId, // 订单号
                        'uid': item.uid, // UID
                        'orderStatus': item.orderStatusStr, // 订单状态
                        'contractName':item.contractName, // 合约
                        'orderType': item.typeText, // 订单类型
                        // 'open': item.open === 'OPEN' ? this.$t('entrustedList.text11') : this.$t('entrustedList.text12'), // 仓位方向
                        'open': item.orderSide, // 仓位方向
                        'orderSide': item.openOrigin === "BUY" ? this.$t('positionList.sideBuy') : this.$t('positionList.sideSell'), // 方向
                        "orderValue": item.orderValue,//委托价值
                        'dealPrice': item.dealPrice, // 成交均价
                        'volume': item.volume, // 委托数量
                        'dealVolume': `${item.dealVolume}`, // 成交数量
                        'fee': item.fee, // 手续费
                        'startTime': item.startTime ? formatTime(Number(item.startTime)) : '--', // 创建时间
                        'marginCoin': item.marginCoin,// 保证金币种
                        'memo': item.memo,
                        'sideType': item.openOrigin,
                        'openType': item.open,

                    })
                })
            }
            if (arr.length === 0) {
                this.notData = true
            }
            this.tableList = arr
        },
        returnVolume(data) {
            if ((data.orderType === 2 && data.open === 'OPEN') || data.volume == 0) {
                // 市价
                // return `${data.volume}${data.marginCoin}`
                return '--'
            }
            // 其他
            return `${fixD(data.volume, 0)} ${this.$t('symbolManagement.unit')}`
        },
        // 导出
        exports(istrue) {
            if (
                istrue !== "true" &&
                this.pages.total &&
                Number(this.pages.total) > this.exportNumLimit
            ) {
                this.exportsModalShow = true;
            } else {
                if (!this.isexportIng) return;
                this.isexportIng = false;
                const paramsData = {
                    uid: this.searchUid,
                    orderId: this.searchOrderNum,
                    contractId: this.contractId ? this.contractId.value : null,
                    orderType: this.type ? this.type.value : null,
                    orderStatus: this.status ? this.status.value : null,
                    startTime: this.dateArray && this.dateArray[0] ? this.beginDate : null,
                    endTime: this.dateArray && this.dateArray[1] ? this.endDate : null,
                    pageNum: this.pages.page,
                    pageSize: this.exportNumLimit,
                    isExport: 1,
                };

                this.outExcel(
                    this.$store.state.url.agent.orderPage,
                    paramsData,
                    "increment-api"
                ).then((datas) => {
                    if (datas.code === "0") {
                        this.$bus.$emit("alert", {
                            type: "success",
                            message: this.$t("common.exportSuccess"),
                        }); // 导出成功
                        this.exportsModalShow = false;
                        setTimeout(() => {
                            this.isexportIng = true;
                        }, 500);
                    } else {
                        this.$bus.$emit("alert", {
                            type: "error",
                            message: this.$t("common.exportError"),
                        }); // 导出失败
                    }
                });
            }
        },
        changeModalShow(data) {
            this.modalShow = data;
        },
        changeModalType(data) {
            this.modalType = data;
        },
        onReset() {
            this.exportsModalShow = false;
        },
        // 分页
        pageChange(data) {
            const { page, pageSize } = data;
            this.pages.page = page;
            this.pages.size = pageSize;
            const v = "page";
            this.getData(v);
        },
    },
};
</script>

<style lang="scss">
#agentEntrustList {
    .header-top {
        border-radius: 0px 0px 16px 16px !important;
    }

    .add-tab {
        position: absolute;
        top: 16px;
        right: 26px;
    }

    .custom-control {
        top: 5px !important;
    }
}
</style>